<div class="is-center h-100">
  <div
    [ngStyle]="contentStyle"
    class="notification-box pointer-events-none"
    (click)="onNotificationBellClick()"
  >
    <div
      class="notification-badge"
      [ngClass]="{ 'hide-badge': !unreadCount || unreadCount === 0 }"
      [style.background-color]="attri.css_config.alertColor"
    ></div>
    <mat-icon [svgIcon]="icon" [ngStyle]="iconStyle"></mat-icon>
  </div>
</div>
